<p>view-offer-modal works!</p>
